import type {
  StatusCustodiaEquipamento,
  StatusEstadiaCliente,
  TipoChamadoClienteEstadia,
  ProcessoMovimentacao,
  MetodoEntrega,
} from '../../models';

export { METODO_ENTREGA_LABELS } from '../SolicitacaoDetailsPage/solicitacaoDetailsPage.definitions';

/** Uber/pessoalmente: envio e chegada acontecem no mesmo dia — 1 campo de data só, mesmo
 * padrão de MovimentacaoLogisticaSection (METODOS_COM_DATA_UNICA). */
export const METODOS_COM_DATA_UNICA: MetodoEntrega[] = ['uber', 'pessoalmente'];

/** Rótulos da aba Custódia (a aba Ativos usa os de ativos.definitions, agrupados). Os 6
 * primeiros são os originais; 'devolvido' = devolução entregue à Raro (ver
 * StatusCustodiaEquipamento), por isso o "à Raro" explícito. */
export const STATUS_CUSTODIA_LABELS: Record<StatusCustodiaEquipamento, string> = {
  estoque_raro: 'Estoque Raro',
  em_transito: 'Em Trânsito',
  em_homologacao: 'Em Homologação',
  com_colaborador: 'Em Uso',
  com_cliente: 'Com Cliente',
  devolvido: 'Devolvido à Raro',
  em_configuracao: 'Em Configuração',
  em_preparo: 'Em Preparo',
  aguardando_devolucao: 'Aguardando Devolução',
  em_manutencao: 'Em Manutenção',
  devolvido_cliente: 'Devolvido ao Cliente',
  inativo: 'Inativo',
};

export const STATUS_CUSTODIA_BADGE_CLASS: Record<StatusCustodiaEquipamento, string> = {
  estoque_raro: 'bg-gray-100 text-gray-700',
  em_transito: 'bg-blue-100 text-blue-800',
  em_homologacao: 'bg-purple-100 text-purple-800',
  com_colaborador: 'bg-green-100 text-green-800',
  com_cliente: 'bg-teal-100 text-teal-800',
  devolvido: 'bg-gray-100 text-gray-500',
  em_configuracao: 'bg-indigo-100 text-indigo-800',
  em_preparo: 'bg-amber-100 text-amber-800',
  aguardando_devolucao: 'bg-orange-100 text-orange-800',
  em_manutencao: 'bg-yellow-100 text-yellow-800',
  devolvido_cliente: 'bg-teal-50 text-teal-700',
  inativo: 'bg-red-100 text-red-700',
};

export const STATUS_CUSTODIA_OPCOES: StatusCustodiaEquipamento[] = [
  'estoque_raro',
  'em_transito',
  'em_homologacao',
  'com_colaborador',
  'com_cliente',
  'devolvido',
  'em_configuracao',
  'em_preparo',
  'aguardando_devolucao',
  'em_manutencao',
  'devolvido_cliente',
  'inativo',
];

export const STATUS_ESTADIA_CLIENTE_LABELS: Record<StatusEstadiaCliente, string> = {
  em_transito: 'Em Trânsito',
  em_homologacao: 'No Cliente', // vale pra qualquer motivo (homologação, remoção de imagem...) — o motivo aparece à parte
  pronta_aguardando_destino: 'Pronta — aguardando destino',
  encerrada: 'Encerrada',
};

export const STATUS_ESTADIA_CLIENTE_BADGE_CLASS: Record<StatusEstadiaCliente, string> = {
  em_transito: 'bg-blue-100 text-blue-800',
  em_homologacao: 'bg-purple-100 text-purple-800',
  pronta_aguardando_destino: 'bg-green-100 text-green-800',
  encerrada: 'bg-gray-100 text-gray-500',
};

export const STATUS_ESTADIA_CLIENTE_OPCOES: StatusEstadiaCliente[] = [
  'em_transito',
  'em_homologacao',
  'pronta_aguardando_destino',
  'encerrada',
];

export const TIPO_CHAMADO_CLIENTE_LABELS: Record<TipoChamadoClienteEstadia, string> = {
  homologacao_estoque: 'Homologação/Estoque',
  retirada_configuracao: 'Retirada/Configuração',
};

/** Por que a máquina foi mandada pro Cliente — mesmos 3 valores da Movimentação de
 * devolução (ver ProcessoMovimentacao), com o emoji já usado no dia a dia do SI. */
export const PROCESSO_MOVIMENTACAO_LABELS: Record<ProcessoMovimentacao, string> = {
  homologacao: '💻 Homologação',
  remocao_imagem: '🧹 Remoção de Imagem',
  devolucao_ao_cliente: '🏢 Devolução ao Cliente',
};

export const PROCESSO_MOVIMENTACAO_OPCOES: ProcessoMovimentacao[] = [
  'homologacao',
  'remocao_imagem',
  'devolucao_ao_cliente',
];
